export const APPENDIX_PAGE_LOCATION = "appendix";
export const RECOMMENDATIONS_PAGE_LOCATION = "recommendations";
export const SIGNATURE_SECTION_IDENTIFIER = "signature";
export const REVIEW_AND_SIGN_ROUTE = "review-and-sign";

export const routeLabelMapping: { [key in string]: string } = {
  "client-details": "Details",
  "upload-files": "Upload Files",
  "report-part-1": "Report Part 1",
  prioritize: "Prioritize",
  "short-term-goals": "Short Term Goals",
  "report-part-2": "Report Part 2",
  conclusions: "Conclusions",
  recommendations: "Recommendations",
  appendix: "Appendix",
  "review-and-sign": "Review",
};

export const orderedAssessmentSubRoutes: string[] = [
  "client-details",
  "upload-files",
  "report-part-1",
  "prioritize",
  "short-term-goals",
  "report-part-2",
  "conclusions",
  "recommendations",
  "appendix",
  "review-and-sign",
];
